import {
  changeSubscription,
  changeSeat,
  getSubscription,
  getSubscriptionProductList
} from "@/api/subscription";

export default {
  namespaced: true,
  state: () => ({
    packageList: [],
    packageName: null, // 套餐名
    packagePrice: null, // 套餐基础价格
    packageOperatorSeatPrice: null, // 套餐 operator seat 增量价格
    packageDriverSeatPrice: null, // 套餐 driver seat 增量价格
    packageOperatorSeatNum: null, // 套餐 operator seat 数量
    packageDriverSeatNum: null, // 套餐 driver seat 数量
    operatorSeatNum: null, // 当前 operator seat 数量
    driverSeatNum: null, // 当前 driver seat 数量,
    operatorNum: null, // 当前 operator 人数,
    driverNum: null, // 当前 driver 人数
    totalPrice: null, // 总计付款
    nextPaymentDate: null, // 下次付款时间
    period: null, // 套餐的扣款周期
    currentTab: null,
    pickedPackage: null, // update页选择的套餐
  }),
  getters: {
    _splitIndex(state) {
      return state.packageList.findIndex(item => {
        return item.name === state.packageName;
      });
    },
    pickedPackageItem(state) {
      return state.packageList.find(item => item.name === state.pickedPackage);
    },
    upgradeList: (state, getters) => {
      const index = getters._splitIndex;
      return index > -1
        ? state.packageList.slice(index + 1)
        : state.packageList;
    },
    downgradeList: (state, getters) => {
      const index = getters._splitIndex;
      return index > -1 ? state.packageList.slice(0, index) : [];
    }
  },
  mutations: {
    SET_SUBSCRIPTION(state, obj) {
      Object.keys(obj).forEach(key => {
        state[key] = obj[key];
      });
    },
    SET_CURRENT_TAB(state, tab) {
      state.currentTab = tab
    },
    SET_PICKEDPACKAGE(state, name) {
      state.pickedPackage = name;
    },
    SET_PACKAGE_LIST(state, list) {
      state.packageList = list
    }
  },
  actions: {
    async _getSubscription({ commit, dispatch }, num = 0) {
      let data = {};
      try {
        const res = await getSubscription();
        data = res.data
      } catch (error) {
        num += 1;
        if (num < 3) {
          dispatch('_getSubscription', num)
        }
        throw error;
      }

      if (!data['product']) {
        num += 1;
        if (num < 5) {
          dispatch('_getSubscription', num)
        }
      }

      commit("SET_SUBSCRIPTION", {
        packageName: data["product"],
        packagePrice: data["main_price"] / 100,
        packageOperatorSeatPrice: data["operator_price"] / 100,
        packageDriverSeatPrice: data["driver_price"] / 100,
        packageOperatorSeatNum: data["package_operator_seat_num"],
        packageDriverSeatNum: data["package_driver_seat_num"],
        operatorSeatNum: data["total_operator_seat_num"],
        driverSeatNum: data["total_driver_seat_num"],
        operatorNum: data["current_operator_num"],
        driverNum: data["current_driver_num"],
        totalPrice: data["order_price"] / 100,
        nextPaymentDate: data["next_payment_time"],
        testAccount: data['test_account'],
        period: data['period'],
      });
    },
    getSubscription({dispatch }) {
      return dispatch("_getSubscription");
    },
    changeSubscription({ dispatch }, name) {
      return changeSubscription(name).then(() => {
        return dispatch("_getSubscription");
      });
    },
    changeSeat({ dispatch }, data) {
      return changeSeat(data).then(() => {
        return dispatch("_getSubscription");
      });
    },
    changeTab({ commit, state }, tab) {
      if (state.currentTab !== tab) {
        commit('SET_CURRENT_TAB', tab)
      }
    },
    _getProduct({ commit }) {
      return getSubscriptionProductList().then(res => {
        commit('SET_PACKAGE_LIST', res.data)
        return res.data
      }).catch(() => {
        commit('SET_PACKAGE_LIST', [])
        return []
      })
    },
    getProduct({ state, dispatch }) {
      if (state.packageList.length) {
        return state.packageList
      }
      return dispatch('_getProduct')
    }
  }
};
